import { APPROVED_CONCEPT_ASSETS } from './referenceAssets.js';

const LOCKED_DIMENSION = Object.freeze({ width: 941, height: 1672 });

function hasLockedMetadata(asset) {
  return Boolean(
    asset?.file
      && asset?.sha256
      && asset.sha256.length === 64
      && asset.width === LOCKED_DIMENSION.width
      && asset.height === LOCKED_DIMENSION.height,
  );
}

/**
 * Browser runtime gate.
 *
 * The approved concept masters are SOURCE references, not production runtime
 * files. Their exact PNG bytes are enforced before dev/build/deploy by
 * `npm run verify:concept`; they are intentionally not all emitted into dist.
 *
 * Runtime readiness therefore validates the locked reference registry rather
 * than issuing HTTP HEAD requests for source-only paths that do not exist in
 * the Vite production bundle.
 */
export async function inspectConceptArtAvailability() {
  const assets = APPROVED_CONCEPT_ASSETS.map((asset) => ({
    ...asset,
    available: hasLockedMetadata(asset),
  }));

  return {
    ready: assets.every((asset) => asset.available),
    assets,
    missing: assets.filter((asset) => !asset.available),
  };
}
